"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = exports.apiReducer = exports.Context = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var initialState = {};
exports.initialState = initialState;

var apiReducer = function apiReducer(state, action) {
  var stateChange = {};
  var updatedObj = {};

  switch (action.type) {
    case _constant.ACTION_CONSTANTS.DATA_FETCH_START:
      {
        updatedObj = {
          isFetching: true,
          data: {},
          isError: false
        };

        if (Object.prototype.hasOwnProperty.call(state, action.payload.key)) {
          state[action.payload.key] = updatedObj;
          return _objectSpread({}, state);
        }

        var key = action.payload.key;
        stateChange[key] = updatedObj;
        return _objectSpread(_objectSpread({}, state), stateChange);
      }

    case _constant.ACTION_CONSTANTS.DATA_FETCH_SUCCESS:
      {
        updatedObj = {
          data: action.payload.json.data,
          isFetching: false,
          isError: false
        };

        if (Object.prototype.hasOwnProperty.call(state, action.payload.key)) {
          state[action.payload.key] = updatedObj;
          return _objectSpread({}, state);
        }

        var _key = action.payload.key;
        stateChange[_key] = updatedObj;
        return _objectSpread(_objectSpread({}, state), stateChange);
      }

    case _constant.ACTION_CONSTANTS.DATA_FETCH_FAILURE:
      {
        updatedObj = {
          data: {},
          isFetching: false,
          isError: true
        };

        if (Object.prototype.hasOwnProperty.call(state, action.payload.key)) {
          state[action.payload.key] = updatedObj;
          return _objectSpread({}, state);
        }

        var _key2 = action.payload.key;
        stateChange[_key2] = updatedObj;
        return _objectSpread(_objectSpread({}, state), stateChange);
      }

    default:
      return state;
  }
};

exports.apiReducer = apiReducer;

var Context = /*#__PURE__*/_react.default.createContext();

exports.Context = Context;

var Store = function Store(_ref) {
  var children = _ref.children;

  var _useReducer = (0, _react.useReducer)(apiReducer, initialState),
      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
      store = _useReducer2[0],
      dispatch = _useReducer2[1];

  return /*#__PURE__*/_react.default.createElement(Context.Provider, {
    value: {
      store: store,
      dispatch: dispatch
    }
  }, children);
};

var _default = Store;
exports.default = _default;
Store.propTypes = {
  children: _propTypes.node.isRequired
};